import { render, staticRenderFns } from "./IP_RebuttalsByAuditor.vue?vue&type=template&id=52945179&scoped=true&"
import script from "./IP_RebuttalsByAuditor.vue?vue&type=script&lang=js&"
export * from "./IP_RebuttalsByAuditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52945179",
  null
  
)

export default component.exports